// extracted by mini-css-extract-plugin
export default {"container":"MobileImpressumScreen_container__CzyI5","gaplessBox":"MobileImpressumScreen_gaplessBox__FGUlN"};